import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import useViewContext from '@modules/order/hooks/use-view-context'
import { productPriceStore } from '@stores/productPricesStore'
import get from 'lodash/get'
import last from 'lodash/last'
import split from 'lodash/split'
import { useObserver } from 'mobx-react-lite'
import React, { FC, useMemo } from 'react'
import FieldSkeleton from '../../../CellLoaders/FieldSkeleton'
import HierarchyCell from '../../components/HierarchyCell'
import Typography from '@components/std-components/Typography'
import formatCurrencyValueByLocale from '@utils/format-currency-value-by-locale'

const HierarchyKPICurrencyDetails: FC<CellItem> = ({ rowData, column }) =>
  useObserver(function useHook() {
    const { uiStore } = useViewContext()
    const hierarchy = uiStore.getHierarchy(rowData.name)
    const kpiField = useMemo(
      () => `kpis.${last(split(column.field, '.'))}`,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [column.field]
    )
    if (!rowData) {
      return (
        <HierarchyCell>
          <FieldSkeleton />
        </HierarchyCell>
      )
    }
    const priceData = productPriceStore.getPriceForProduct(rowData?.id)
    const value = get(last(hierarchy), kpiField)
    return (
      <HierarchyCell>
        <Typography variant='subHeading1'>
          {value
            ? formatCurrencyValueByLocale(
                priceData.kpiCurrency ? priceData.kpiCurrency : priceData.rtlCurrency,
                value
              )
            : 0}
        </Typography>
      </HierarchyCell>
    )
  })

export default HierarchyKPICurrencyDetails
